import {AMAZON_AF_DEFAULT_DISK_IMAGE} from '~/common/affiliate/amazon';

export const selectGiftingOptions = ({giftingOptions}) => giftingOptions;

export const selectGiftingData = ({gifting}) => ({
  url: gifting?.url || 'https://www.amazon.com/?tag=web-tracking-20',
  iconUrl: gifting?.iconUrl || AMAZON_AF_DEFAULT_DISK_IMAGE,
  vendorName: gifting?.vendorName || 'Amazon',
});
